import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase'; // auth eklendi (Loglama için)
import { collection, onSnapshot, query, writeBatch, doc, where, getDocs } from 'firebase/firestore';
import Modal from '../components/Modal';
// Loglama Aracı
import { logIslem } from '../utils/logger';

function Musteriler() {
  
  const [cariler, setCariler] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  const navigate = useNavigate(); 

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCari, setSelectedCari] = useState(null); 
  const [modalLoading, setModalLoading] = useState(false);

  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // --- TÜM CARİLERİ ÇEK ---
  useEffect(() => {
    const q = query(collection(db, 'cariler'));
    
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const carilerList = [];
      querySnapshot.forEach((doc) => {
        carilerList.push({ id: doc.id, ...doc.data() });
      });
      
      // A-Z Sıralama
      carilerList.sort((a, b) => (a.adSoyad || a.firmaSahis || '').localeCompare(b.adSoyad || b.firmaSahis || ''));
      
      setCariler(carilerList);
      setLoading(false);
    }, (err) => {
      console.error("Hata:", err);
      setError("Veriler yüklenemedi.");
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // --- LİSTELERİ AYIR ---
  const musteriListesi = cariler.filter(c => c.cariTipi === 'Müşteri' || !c.cariTipi); // Varsayılan Müşteri
  const tedarikciListesi = cariler.filter(c => c.cariTipi === 'Tedarikçi');

  // --- YÖNLENDİRME ---
  const handleRowClick = (cari) => {
    if (cari.cariTipi === 'Tedarikçi') {
        navigate(`/tedarikciler/${cari.id}`);
    } else {
        navigate(`/cariler/${cari.id}`); 
    }
  };
  
  // --- SİLME İŞLEMLERİ ---
  const handleDeleteClick = (e, cari) => {
    e.stopPropagation(); 
    setSelectedCari(cari); 
    setIsModalOpen(true); 
  };
  
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCari(null);
  };
  
  const handleConfirmDelete = async () => {
    if (!selectedCari) return;
    setModalLoading(true);
    const silinecekIsim = selectedCari.adSoyad || selectedCari.firmaSahis;
    const userEmail = auth.currentUser ? auth.currentUser.email : "Bilinmeyen";

    try {
      const batch = writeBatch(db);
      const cariId = selectedCari.id;
      
      // 1. Cariyi sil
      const cariRef = doc(db, 'cariler', cariId);
      batch.delete(cariRef);
      
      // 2. Bağlı kayıtları sil
      const taksitlerQuery = query(collection(db, 'taksitler'), where("cariId", "==", cariId));
      const odemelerQuery = query(collection(db, 'odemeler'), where("cariId", "==", cariId));

      const [taksitlerSnapshot, odemelerSnapshot] = await Promise.all([
        getDocs(taksitlerQuery),
        getDocs(odemelerQuery)
      ]);
      
      taksitlerSnapshot.forEach((doc) => { batch.delete(doc.ref); });
      odemelerSnapshot.forEach((doc) => { batch.delete(doc.ref); });
      
      await batch.commit();

      // LOG
      logIslem("Cari Silme", `Silinen: ${silinecekIsim} (ID: ${cariId})`, userEmail);

    } catch (err) {
      alert("Silme işlemi başarısız oldu.");
    }
    setModalLoading(false);
    handleCloseModal();
  };

  return (
    <> 
      <div className="admin-page">
        
        {/* --- HEADER --- */}
        <div className="admin-header">
          <h1 
              className="brand-logo admin-brand-header"
              onClick={() => navigate('/admin/dashboard')}
              style={{ cursor: 'pointer' }}
              title="Panele Dön"
          >
            <img src="/logo.png" width="50" alt="" />
            ARAS ASAF – GENEL CARİ LİSTESİ
          </h1>

          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <div className="date-time-info">
                {now.toLocaleDateString("tr-TR")} | {now.toLocaleTimeString("tr-TR")}
              </div>
              
              <button 
                onClick={() => navigate('/admin/dashboard')} 
                className="admin-button-secondary small"
              >
                ← Geri Dön
              </button>
          </div>
        </div>
        
        {loading && <p className="loading-text">Veriler yükleniyor...</p>}
        {error && <p className="login-error">{error}</p>}
        
        {!loading && !error && (
          <>
            {/* --- TABLO 1: MÜŞTERİLER (YEŞİL) --- */}
            <div className="admin-table-container">
                <h2 style={{ color: '#28a745', borderBottom: '2px solid #28a745', paddingBottom: '10px', marginBottom: '15px' }}>
                    👥 MÜŞTERİ LİSTESİ (TAHSİLAT)
                </h2>
                <table className="admin-table">
                <thead>
                    <tr>
                    <th>Firma / Şahıs</th>
                    <th>Yetkili Adı</th>
                    <th>Telefon</th>
                    <th>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    {musteriListesi.map((cari) => (
                    <tr key={cari.id} className="table-row-clickable" onClick={() => handleRowClick(cari)}>
                        <td>{cari.firmaSahis || '---'}</td>
                        <td>{cari.adSoyad || '---'}</td>
                        <td>{cari.telefon}</td>
                        <td style={{ textAlign: 'center' }}>
                        <button className="admin-button-delete" onClick={(e) => handleDeleteClick(e, cari)}>Sil</button>
                        </td>
                    </tr>
                    ))}
                    {musteriListesi.length === 0 && <tr><td colSpan="4" style={{ textAlign: 'center' }}>Kayıtlı müşteri yok.</td></tr>}
                </tbody>
                </table>
            </div>

            {/* --- TABLO 2: TEDARİKÇİLER (KIRMIZI) --- */}
            <div className="admin-table-container" style={{ marginTop: '30px' }}>
                <h2 style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: '10px', marginBottom: '15px' }}>
                    🚚 TEDARİKÇİ LİSTESİ (ÖDEMELER)
                </h2>
                <table className="admin-table">
                <thead>
                    <tr>
                    <th>Firma / Şahıs</th>
                    <th>Yetkili Adı</th>
                    <th>Telefon</th>
                    <th>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    {tedarikciListesi.map((cari) => (
                    <tr key={cari.id} className="table-row-clickable" onClick={() => handleRowClick(cari)}>
                        <td>{cari.firmaSahis || '---'}</td>
                        <td>{cari.adSoyad || '---'}</td>
                        <td>{cari.telefon}</td>
                        <td style={{ textAlign: 'center' }}>
                        <button className="admin-button-delete" onClick={(e) => handleDeleteClick(e, cari)}>Sil</button>
                        </td>
                    </tr>
                    ))}
                    {tedarikciListesi.length === 0 && <tr><td colSpan="4" style={{ textAlign: 'center' }}>Kayıtlı tedarikçi yok.</td></tr>}
                </tbody>
                </table>
            </div>
          </>
        )}
      </div>

      {/* Silme Modalı */}
      <Modal
        show={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        title="Cari Silme Onayı"
      >
        {modalLoading ? ( <p>Siliniyor...</p> ) : (
          selectedCari && (
            <p>
              <b>{selectedCari.adSoyad || selectedCari.firmaSahis}</b> <br/>
              isimli kaydı silmek istediğinize emin misiniz?
              <br/><br/>
              <strong style={{ color: '#A94442' }}>
                UYARI: Bu kişiye ait TÜM borç/alacak kayıtları silinecektir!
              </strong>
            </p>
          )
        )}
      </Modal>
    </>
  );
}

export default Musteriler;